import { SearchSource } from '@carvana/merch-contracts';
import {
  EventAction,
  EventDescription
} from '@carvana/merch-search-bar/constants';
import type SuggestionInfo from '~/contracts/common/SuggestionInfo';
import type ComposerSuggestionInfo from '~/contracts/composer/ComposerSuggestionInfo';

export default function buildComposerSuggestionInfo(
  suggestionInfo: ComposerSuggestionInfo
): Partial<SuggestionInfo> {
  return {
    ...suggestionInfo,
    action: EventAction.Clicked,
    description: EventDescription.Suggestion,
    isStickySearchbar: false,
    suggestionSource: SearchSource.Composer
  };
}
